import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'

// constants
export const FETCH_SITE_LIST = 'dataBrowser/FETCH_SITE_LIST'
export const SUCCESS_SITE_LIST = 'dataBrowser/SUCCESS_SITE_LIST'
export const FAILURE_SITE_LIST = 'dataBrowser/FAILURE_SITE_LIST'

export const FETCH_LOCUS_GROUP_LIST = 'dataBrowser/FETCH_LOCUS_GROUP_LIST'
export const SUCCESS_LOCUS_GROUP_LIST = 'dataBrowser/SUCCESS_LOCUS_GROUP_LIST'
export const FAILURE_LOCUS_GROUP_LIST = 'dataBrowser/FAILURE_LOCUS_GROUP_LIST'

export const FETCH_LOCUS_LIST = 'dataBrowser/FETCH_LOCUS_LIST'
export const SUCCESS_LOCUS_LIST = 'dataBrowser/SUCCESS_LOCUS_LIST'
export const FAILURE_LOCUS_LIST = 'dataBrowser/FAILURE_LOCUS_LIST'

export const FETCH_SENSOR_LIST = 'dataBrowser/FETCH_SENSOR_LIST'
export const [FETCH_SENSOR_LIST_SUCCESS, FETCH_SENSOR_LIST_FAILURE] = [
  `${FETCH_SENSOR_LIST}_SUCCESS`,
  `${FETCH_SENSOR_LIST}_FAILURE`,
]

export const FETCH_DB_LOGBOOK_EVENT_LIST =
  'dataBrowser/FETCH_DB_LOGBOOK_EVENT_LIST'
export const SUCCESS_DB_LOGBOOK_EVENT_LIST =
  'dataBrowser/SUCCESS_DB_LOGBOOK_EVENT_LIST'
export const FAILURE_DB_LOGBOOK_EVENT_LIST =
  'dataBrowser/FAILURE_DB_LOGBOOK_EVENT_LIST'

export const FETCH_PRODUCTION_DATA = 'dataBrowser/FETCH_PRODUCTION_DATA'
export const SUCCESS_PRODUCTION_DATA = 'dataBrowser/SUCCESS_PRODUCTION_DATA'
export const FAILURE_PRODUCTION_DATA = 'dataBrowser/FAILURE_PRODUCTION_DATA'

export const FETCH_ENVIRONMENT_DATA = 'dataBrowser/FETCH_ENVIRONMENT_DATA'
export const SUCCESS_ENVIRONMENT_DATA = 'dataBrowser/SUCCESS_ENVIRONMENT_DATA'
export const FAILURE_ENVIRONMENT_DATA = 'dataBrowser/FAILURE_ENVIRONMENT_DATA'

export const FETCH_LOGBOOK_DATA = 'dataBrowser/FETCH_LOGBOOK_DATA'
export const SUCCESS_LOGBOOK_DATA = 'dataBrowser/SUCCESS_LOGBOOK_DATA'
export const FAILURE_LOGBOOK_DATA = 'dataBrowser/FAILURE_LOGBOOK_DATA'

export const SET_LICENSEE_LIST_LOADER = 'dataBrowser/SET_LICENSEE_LIST_LOADER'
export const SET_SITE_LIST_LOADER = 'dataBrowser/SET_SITE_LIST_LOADER'
export const SET_LOCUS_GROUP_LIST_LOADER =
  'dataBrowser/SET_LOCUS_GROUP_LIST_LOADER'
export const SET_LOCUS_LIST_LOADER = 'dataBrowser/SET_LOCUS_LIST_LOADER'

export const SET_ACTIVE_PRODUCTIONS = 'dataBrowser/SET_ACTIVE_PRODUCTIONS'
export const SET_ACTIVE_ENVIRONMENT = 'dataBrowser/SET_ACTIVE_ENVIRONMENT'
export const SET_ACTIVE_LOGBOOK = 'dataBrowser/SET_ACTIVE_LOGBOOK'
export const SET_ACTIVE_DATE = 'dataBrowser/SET_ACTIVE_DATE_RANGE'
export const SET_ACTIVE_LOCUS_GROUP = 'dataBrowser/SET_ACTIVE_LOCUS_GROUP'
export const SET_ACTIVE_LOCUS = 'dataBrowser/SET_ACTIVE_LOCUS'
export const EXPORT_TO_CSV = 'dataBrowser/EXPORT_TO_CSV'

export const CLEAR_PRODUCTION_AND_HEALTH =
  'dataBrowser/CLEAR_PRODUCTION_AND_HEALTH'
export const CLEAR_ENVIRONMENT = 'dataBrowser/CLEAR_ENVIRONMENT'
export const CLEAR_LOGBOOK = 'dataBrowser/CLEAR_LOGBOOK'
export const CLEAR_STORE = 'dataBrowser/CLEAR_STORE'

// actions
export const fetchSiteList = ActionHelper.createActionObj(FETCH_SITE_LIST)
export const fetchLocusGroupList = ActionHelper.createActionObj(
  FETCH_LOCUS_GROUP_LIST,
)
export const fetchLocusList = ActionHelper.createActionObj(FETCH_LOCUS_LIST)
export const fetchSensorList = ActionHelper.createActionObj(FETCH_SENSOR_LIST)

export const setActiveLocusGroup = ActionHelper.createActionObj(
  SET_ACTIVE_LOCUS_GROUP,
)
export const setActiveLocus = ActionHelper.createActionObj(SET_ACTIVE_LOCUS)

export const fetchDbLogbookEventList = ActionHelper.createActionObj(
  FETCH_DB_LOGBOOK_EVENT_LIST,
)
export const fetchProductionData = ActionHelper.createActionObj(
  FETCH_PRODUCTION_DATA,
)
export const fetchEnvironmentData = ActionHelper.createActionObj(
  FETCH_ENVIRONMENT_DATA,
)
export const fetchLogbookData = ActionHelper.createActionObj(FETCH_LOGBOOK_DATA)

export const setActiveProductions = ActionHelper.createActionObj(
  SET_ACTIVE_PRODUCTIONS,
)
export const setActiveEnvironment = ActionHelper.createActionObj(
  SET_ACTIVE_ENVIRONMENT,
)
export const setActiveLogbook = ActionHelper.createActionObj(SET_ACTIVE_LOGBOOK)
export const setActiveDate = ActionHelper.createActionObj(SET_ACTIVE_DATE)
export const exportToCsv = ActionHelper.createActionObj(EXPORT_TO_CSV)

export const clearProductionAndHealthData = ActionHelper.createActionObj(
  CLEAR_PRODUCTION_AND_HEALTH,
)
export const clearEnvironmentData = ActionHelper.createActionObj(
  CLEAR_ENVIRONMENT,
)
export const clearLogbookData = ActionHelper.createActionObj(CLEAR_LOGBOOK)
export const clearStore = ActionHelper.createActionObj(CLEAR_STORE)

// store
const initialState = () =>
  fromJS({
    isLoadSiteList: false,
    isLoadLocusGroupList: false,
    isLoadLocusList: false,
    isLoadSilo: false,
    isLoadChart: false,
    isLoadProductionData: false,
    isLoadEnvironmentData: false,
    isLoadLogbookData: false,
    siteList: [],
    locusGroupList: [],
    locusList: [],
    activeLocusGroup: 0,
    activeLocus: 0,
    activeProductions: {
      value: null,
      name: '',
    },
    activeEnvironment: {
      id: null,
      name: '',
      sensor_type_id: null,
    },
    activeLogbookType: {
      id: null,
      name: '',
    },

    siloList: [],
    logbookEventList: [],
    data: [],
    productionData: [],
    environmentData: [],
    logbookData: {
      type: '',
      items: [],
    },
    sensorList: [],
  })

const dataBrowser = handleActions(
  {
    [SUCCESS_SITE_LIST]: (state, action) =>
      state.set('siteList', List(action.payload)),
    [FAILURE_SITE_LIST]: state => state.set('siteList', List([])),

    [SUCCESS_LOCUS_GROUP_LIST]: (state, action) =>
      state.set('locusGroupList', List(action.payload)),
    [FAILURE_LOCUS_GROUP_LIST]: state => state.set('locusGroupList', List([])),

    [SUCCESS_LOCUS_LIST]: (state, action) =>
      state.set('locusList', List(action.payload)),
    [FAILURE_LOCUS_LIST]: state => state.set('locusList', List([])),

    [FETCH_SENSOR_LIST_SUCCESS]: (state, action) =>
      state.set('sensorList', List(action.payload)),
    [FETCH_SENSOR_LIST_FAILURE]: state => state.set('sensorList', List([])),

    [SET_SITE_LIST_LOADER]: (state, action) =>
      state.set('isLoadSiteList', Boolean(action.payload)),
    [SET_LOCUS_GROUP_LIST_LOADER]: (state, action) =>
      state.set('isLoadLocusGroupList', Boolean(action.payload)),
    [SET_LOCUS_LIST_LOADER]: (state, action) =>
      state.set('isLoadLocusList', Boolean(action.payload)),

    [SET_ACTIVE_LOCUS_GROUP]: (state, action) =>
      state.set('activeLocusGroup', action.payload),
    [SET_ACTIVE_LOCUS]: (state, action) =>
      state.set('activeLocus', action.payload),

    [SUCCESS_DB_LOGBOOK_EVENT_LIST]: (state, action) =>
      state.set('logbookEventList', List(action.payload)),
    [FAILURE_DB_LOGBOOK_EVENT_LIST]: state =>
      state.set('logbookEventList', List([])),

    [SET_ACTIVE_PRODUCTIONS]: (state, action) =>
      state.set('activeProductions', Map(action.payload)),
    [SET_ACTIVE_ENVIRONMENT]: (state, action) =>
      state.set('activeEnvironment', Map(action.payload)),
    [SET_ACTIVE_LOGBOOK]: (state, action) =>
      state.set('activeLogbookType', Map(action.payload)),
    [SET_ACTIVE_DATE]: (state, action) =>
      state.set('activeDateRange', Map(action.payload)),

    [FETCH_PRODUCTION_DATA]: state => state.set('isLoadProductionData', true),
    [SUCCESS_PRODUCTION_DATA]: (state, action) =>
      state
        .set('productionData', List(action.payload))
        .set('isLoadProductionData', false),
    [FAILURE_PRODUCTION_DATA]: state =>
      state
        .set('productionData', initialState().get('productionData'))
        .set('isLoadProductionData', false),
    [CLEAR_PRODUCTION_AND_HEALTH]: state =>
      state
        .set('productionData', initialState().get('productionData'))
        .set('activeProductions', initialState().get('activeProductions')),

    [FETCH_ENVIRONMENT_DATA]: state => state.set('isLoadEnvironmentData', true),
    [SUCCESS_ENVIRONMENT_DATA]: (state, action) =>
      state
        .set('environmentData', List(action.payload))
        .set('isLoadEnvironmentData', false),
    [FAILURE_ENVIRONMENT_DATA]: state =>
      state
        .set('environmentData', initialState().get('environmentData'))
        .set('isLoadEnvironmentData', false),
    [CLEAR_ENVIRONMENT]: state =>
      state
        .set('environmentData', initialState().get('environmentData'))
        .set('activeEnvironment', initialState().get('activeEnvironment')),

    [FETCH_LOGBOOK_DATA]: state => state.set('isLoadLogbookData', true),
    [SUCCESS_LOGBOOK_DATA]: (state, action) =>
      state
        .set('logbookData', Map(action.payload))
        .set('isLoadLogbookData', false),
    [FAILURE_LOGBOOK_DATA]: state =>
      state
        .set('logbookData', initialState().get('logbookData'))
        .set('isLoadLogbookData', false),
    [CLEAR_LOGBOOK]: state =>
      state
        .set('logbookData', initialState().get('logbookData'))
        .set('activeLogbookType', initialState().get('activeLogbookType')),

    [ActionHelper.SET_ANY_PARAMS_STORE]: ActionHelper.setAnyParamsStore,

    [CLEAR_STORE]: () => initialState(),
  },
  initialState(),
)

export default dataBrowser
